import {useCallback, useState, type FocusEvent} from 'react'
import {validateRequired} from '@/lib/validation'

export type LicenciaFieldErrors = {numero?: string; vigencia?: string}

export function useLicenciaFieldErrors() {
  const [fieldErrors, setFieldErrors] = useState<LicenciaFieldErrors>({})

  const blurNumero = useCallback((e: FocusEvent<HTMLInputElement>) => {
    setFieldErrors((fe) => ({...fe, numero: validateRequired(e.target.value) ?? undefined}))
  }, [])

  const blurVigencia = useCallback((e: FocusEvent<HTMLInputElement>) => {
    setFieldErrors((fe) => ({...fe, vigencia: validateRequired(e.target.value) ?? undefined}))
  }, [])

  const clearNumero = useCallback(() => {
    setFieldErrors((fe) => ({...fe, numero: undefined}))
  }, [])

  const clearVigencia = useCallback(() => {
    setFieldErrors((fe) => ({...fe, vigencia: undefined}))
  }, [])

  const validate = useCallback((numero: string, vigencia: string): LicenciaFieldErrors => {
    const errors: LicenciaFieldErrors = {}
    const numeroErr = validateRequired(numero)
    if (numeroErr) errors.numero = numeroErr
    const vigenciaErr = validateRequired(vigencia)
    if (vigenciaErr) errors.vigencia = vigenciaErr
    setFieldErrors(errors)
    return errors
  }, [])

  return {fieldErrors, blurNumero, blurVigencia, clearNumero, clearVigencia, validate}
}
